import type { IconSvgObject } from './types';

const BetweenHorizontalEndIcon: IconSvgObject = [
  ["path", { d: "M22 10L20 12L22 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 10L4 12L2 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 18.5V15.5C6 14.6716 6.67157 14 7.5 14H16.5C17.3284 14 18 14.6716 18 15.5V18.5C18 19.3284 17.3284 20 16.5 20H7.5C6.67157 20 6 19.3284 6 18.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6 8.5V5.5C6 4.67157 6.67157 4 7.5 4H16.5C17.3284 4 18 4.67157 18 5.5V8.5C18 9.32843 17.3284 10 16.5 10H7.5C6.67157 10 6 9.32843 6 8.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default BetweenHorizontalEndIcon;
